import React from 'react';
import { FadeInUp } from './FadeInUp';
import { X, CheckCircle2 } from 'lucide-react';
export function PsychologicalPricing() {
  return <section className="py-20 px-6 bg-white" data-id="element-238">
      <div className="max-w-4xl mx-auto" data-id="element-239">
        <FadeInUp data-id="element-240">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-12 text-center text-deep-green" data-id="element-241">
            ¿Cuánto vale realmente este conocimiento?
          </h2>
        </FadeInUp>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-242">
          <FadeInUp delay={0.1} data-id="element-243">
            <div className="space-y-6 p-6 md:p-8 bg-cream rounded-3xl border border-black/5" data-id="element-244">
              <div className="flex items-start gap-4 opacity-60" data-id="element-245">
                <X className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-246" />
                <div data-id="element-247">
                  <p className="font-bold text-charcoal line-through" data-id="element-248">
                    Consulta con nutricionista
                  </p>
                  <p className="text-sm text-charcoal/70" data-id="element-249">
                    $30.000 - $50.000 por sesión
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 opacity-60" data-id="element-250">
                <X className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-251" />
                <div data-id="element-252">
                  <p className="font-bold text-charcoal line-through" data-id="element-253">
                    Programa de desinflamación online
                  </p>
                  <p className="text-sm text-charcoal/70" data-id="element-254">$19.000 - $49.000</p>
                </div>
              </div>
              <div className="flex items-start gap-4 opacity-60" data-id="element-255">
                <X className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-256" />
                <div data-id="element-257">
                  <p className="font-bold text-charcoal line-through" data-id="element-258">
                    Coaching de bienestar 1:1
                  </p>
                  <p className="text-sm text-charcoal/70" data-id="element-259">$50.000 - $99.000</p>
                </div>
              </div>
              <div className="flex items-start gap-4 opacity-60" data-id="element-260">
                <X className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-261" />
                <div data-id="element-262">
                  <p className="font-bold text-charcoal line-through" data-id="element-263">
                    Libros + suplementos + prueba y error
                  </p>
                  <p className="text-sm text-charcoal/70" data-id="element-264">$20.000</p>
                </div>
              </div>
            </div>
          </FadeInUp>

          <FadeInUp delay={0.2} data-id="element-265">
            <div className="bg-deep-green text-cream p-8 md:p-10 rounded-3xl shadow-2xl relative overflow-hidden" data-id="element-266">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 rounded-full blur-3xl" data-id="element-267"></div>
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-sage/20 rounded-full blur-3xl" data-id="element-268"></div>

              <div className="relative z-10" data-id="element-269">
                <div className="flex items-center gap-2 mb-6" data-id="element-270">
                  <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-271" />
                  <span className="text-gold font-bold tracking-widest uppercase text-sm" data-id="element-272">
                    Tu Inversión Hoy
                  </span>
                </div>

                <h3 className="font-serif text-3xl md:text-4xl font-bold mb-4" data-id="element-273">
                  Tú lo llevas todo hoy por solo
                </h3>

                <div className="mb-6" data-id="element-274">
                  <span className="font-serif text-6xl md:text-7xl font-bold text-white drop-shadow-sm" data-id="element-275">
                    $4.990
                  </span>
                </div>

                <p className="text-cream/80 text-lg italic border-t border-white/10 pt-6" data-id="element-276">
                  "Eso es menos de lo que cuesta un café en Starbucks, con
                  resultados que duran."
                </p>
              </div>
            </div>
          </FadeInUp>
        </div>
      </div>
    </section>;
}